{
  "branding": {
    "frontdesk-attribution": "FrontDesk+ 제공",
    "practice-logo": "{{name}} 로고"
  },
  "validation": {
    "required": "이 필드는 필수입니다",
    "invalid-url": "유효한 URL을 입력하세요",
    "pin-too-short": "PIN은 최소 4자 이상이어야 합니다",
    "pin-default-rejected": "표준 PIN 0000은 허용되지 않습니다. 자신만의 PIN을 지정해 주세요.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "뒤로",
    "next": "다음",
    "cancel": "취소",
    "confirm": "확인",
    "done": "완료",
    "retry": "다시 시도",
    "clear": "지우기",
    "close": "닫기",
    "verifying": "확인 중...",
    "select": "선택",
    "minutes": "분",
    "clock": "",
    "gender": {
      "M": "남성",
      "W": "여성",
      "D": "다양함",
      "U": "알 수 없음"
    },
    "insurance": {
      "GKV": "법정",
      "PKV": "민간",
      "SELFPAY": "자비 부담"
    },
    "scroll-up": "위로 스크롤",
    "scroll-down": "아래로 스크롤"
  },
  "settings": {
    "device-reset": {
      "title": "기기 초기화",
      "description": "이 기기의 병원 연결, 기기 설정 및 PIN을 삭제합니다.",
      "confirmation": "이 기기를 다시 설정해야 합니다. SOL 설정과 inSuite의 환자 데이터는 변경되지 않습니다.",
      "cancel": "취소",
      "confirm": "지금 초기화"
    },
    "title": "설정",
    "save": "저장",
    "save-success": "설정이 저장되었습니다",
    "save-error": "설정 저장 실패",
    "load-error": "설정 로드 실패",
    "pin": {
      "title": "PIN 필요",
      "description": "설정에 접근하려면 PIN을 입력하세요.",
      "error": "잘못된 PIN입니다. 다시 시도하세요.",
      "backspace": "마지막 숫자 지우기"
    },
    "connection": {
      "title": "연결",
      "description": "Doc-Cirrus Bridge 서버 연결 설정",
      "bridge-url": "Bridge URL",
      "device-name": "장치 이름",
      "device-name-placeholder": "예를 들어 리셉션, 룸 1, 키오스크",
      "device-name-hint": "Bridge 대시보드의 식별을 위한 이름",
      "kim-address": "KIM 주소(선택 사항)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "테스트",
      "success": "연결 성공",
      "error": "연결 실패",
      "api-unreachable": "DocCirrus API에 연결할 수 없음",
      "status-title": "연결 상태",
      "status": {
        "api": "API 연결됨",
        "ti": "텔레매틱스 인프라",
        "card-reader": "카드 리더기 사용 가능",
        "medical-card": "의료기관 카드 (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol 토큰 (inSuite에서)",
      "sol-token-hint": "inSuite의 Bridge 관리에서 복사하세요. 연결에 필요합니다.",
      "sol-token-show": "토큰 표시",
      "sol-token-hide": "토큰 숨기기",
      "bridge-unreachable": "Bridge에 연결할 수 없습니다. 주소와 포트를 확인하세요.",
      "diagnostic-id": "진단 ID: {{id}}",
      "scan-qr": "QR 코드 스캔",
      "scan-title": "Bridge QR 코드 스캔",
      "scan-manual": "직접 입력"
    },
    "terminal": {
      "title": "카드 리더기",
      "description": "원격 의료 인프라용 카드 리더기 선택",
      "select": "터미널 선택",
      "select-placeholder": "터미널을 선택하세요...",
      "loading": "터미널 로드 중...",
      "none-available": "사용 가능한 터미널 없음",
      "none-found": "터미널을 찾을 수 없음",
      "found": "{{count}}개의 터미널 발견",
      "connect-hint": "터미널을 로드하려면 먼저 bridge 서버에 연결하세요.",
      "found-count": "찾은 카드 리더: {{count}}",
      "refresh": "카드 리더 다시 불러오기"
    },
    "practice": {
      "title": "의료기관",
      "description": "의료기관 정보",
      "name": "의료기관 이름",
      "name-placeholder": "예: 김 박사",
      "welcome-message": "환영 메시지",
      "welcome-placeholder": "예: 저희 의료기관에 오신 것을 환영합니다",
      "scheduler-available": "스케줄러 활성화",
      "scheduler-available-description": "환자가 셀프 서비스 단말기를 통해 약속을 예약할 수 있도록 허용",
      "prescription-available": "처방 서비스 활성화",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "비워 두면 환자의 언어로 인사말이 표시됩니다. 직접 입력한 문구는 모든 언어에서 그대로 표시됩니다."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "모든 기기에 저장됨: {{value}}",
      "never-saved-default": "기본 설정, 아직 변경되지 않음."
    },
    "anamnesis": {
      "title": "디지털 의료 기록",
      "description": "체크인 후 병력 제공자에 대한 링크와 QR code를 표시합니다.",
      "enabled": "체크인 후 병력 링크 표시",
      "enabled-description": "체크인이 완료된 후 의료 기록 제공자에 대한 링크와 QR code를 표시합니다(예: Nelly).",
      "url": "병력 제공업체 링크",
      "url-hint": "링크는 모든 환자에 대해 정적이며 동일합니다.",
      "preview-label": "완료 화면 미리보기",
      "preview-note": "링크는 모든 환자에 대해 정적이며 동일합니다.",
      "url-first": "켜려면 먼저 유효한 링크를 입력하세요."
    },
    "appearance": {
      "title": "외관",
      "description": "사용자 인터페이스 사용자 지정",
      "language": "언어",
      "default-kiosk-language": "기본 환자 언어",
      "default-kiosk-language-hint": "환자를 위해 새로운 키오스크 세션이 시작되는 언어입니다.",
      "voice-over-volume": "음성 해설 볼륨",
      "voice-over-hint": "접근성을 위해 음성 해설 도우미의 볼륨을 제어합니다.",
      "language-first": "세션 시작 시 언어 선택 표시"
    },
    "security": {
      "title": "보안",
      "description": "설정 접근용 PIN",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "키오스크 관리",
    "nav": {
      "general": "일반",
      "flows": "기능",
      "anamnese": "디지털 문진",
      "device": "기기 및 연결"
    },
    "flows": {
      "title": "단말기 기능"
    },
    "language": {
      "title": "언어 및 음성 안내",
      "description": "이 기기에서 환자를 위한 언어와 음성 읽기."
    }
  },
  "self-service": {
    "title": "셀프 서비스",
    "step-progress": "단계 {{current}} / {{total}}",
    "flows": {
      "checkin": "체크인",
      "scheduler": "예약하기",
      "prescription": "처방전",
      "locations": "위치 지도",
      "emergency": "응급"
    },
    "audio-guide": {
      "on": "소리 켜짐",
      "off": "소리 꺼짐",
      "replay": "음성 안내 다시 듣기",
      "replay-unavailable": "다시 들을 음성 안내가 없습니다"
    },
    "language-selector": {
      "title": "언어 선택",
      "description": "원하시는 언어를 선택하세요"
    },
    "settings": "설정",
    "start": {
      "welcome": "환영합니다",
      "subtitle": "옵션을 선택하세요",
      "check-in-label": "주요 경로",
      "check-in-cta": "체크인",
      "check-in-description": "이미 예약이 있으신가요? 여기서 체크인하세요.",
      "check-in-hint": "카드를 준비하세요",
      "scheduler-label": "새로운",
      "scheduler-cta": "예약하기",
      "scheduler-description": "새 예약을 잡으세요.",
      "location-plan": "위치 지도",
      "location-plan-description": "진료실까지 가는 길을 찾으세요.",
      "prescription-label": "처방전",
      "prescription-cta": "처방전 및 주문",
      "prescription-description": "처방전을 확인하거나 리필을 주문하세요.",
      "emergency-cta": "기기 내 응급 알림",
      "emergency-description": "이 기기에서만 소리가 나며 도움을 요청하지 않습니다.",
      "tap-to-start": "시작하려면 탭하세요."
    },
    "offline": {
      "banner-title": "일시적으로 체크인 불가",
      "banner-message": "도움이 필요하면 리셉션 직원에게 문의하세요.",
      "emergency-available": "기기 내 알림은 계속 사용할 수 있습니다. 도움을 요청하지 않습니다.",
      "flow-disabled": "일시적으로 이용할 수 없습니다"
    },
    "readability": {
      "toggle-label": "읽기 모드",
      "on": "읽기 모드",
      "off": "읽기 모드"
    },
    "reset-overlay": {
      "timeout-title": "세션이 종료되었습니다.",
      "timeout-subtitle": "귀하의 시간이 만료되었습니다. 귀하의 데이터는 안전합니다.",
      "offline-title": "연결 끊김",
      "offline-subtitle": "연결이 중단되었습니다. 리셉션 직원에게 문의하시기 바랍니다.",
      "interruption-title": "세션이 종료되었습니다.",
      "interruption-subtitle": "귀하의 세션이 안전하게 종료되었습니다.",
      "completion-title": "감사합니다!",
      "completion-subtitle": "귀하의 요청이 성공적으로 완료되었습니다.",
      "reassurance": "귀하의 개인 데이터는 이 장치에 저장되지 않습니다.",
      "auto-dismiss": "{{seconds}}초 후에 시작으로 돌아가는 중...",
      "dismiss": "시작으로 이동"
    },
    "timed-terminal": {
      "countdown": "{{seconds}}초 안에 자동 복귀",
      "countdown-outcome": "이 터미널은 자동으로 시작 화면으로 돌아갑니다.",
      "more-time": "더 많은 시간",
      "extended": "시간 연장"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "이 질문은 선택하신 언어로 제공되지 않습니다. 제공되는 언어를 선택하거나 접수처에 문의해 주세요.",
        "alternatives": "대체 예약",
        "loading": "질문을 불러오는 중…",
        "reception-fallback": "접수처로 가 주세요.",
        "error-title": "질문을 불러올 수 없습니다",
        "language-unavailable-lead": "이 질문은 선택하신 언어로 제공되지 않습니다.",
        "language-unavailable-title": "다음 언어 중 하나를 선택하세요",
        "language-unavailable-body": "또는 접수처에서 도움을 받으세요."
      },
      "start": {
        "title": "예약하기",
        "subtitle": "몇 단계로 원하는 예약을 잡으세요",
        "welcome": "예약 시스템에 오신 것을 환영합니다",
        "description": "예약 과정을 안내해 드리겠습니다",
        "cta": "지금 예약하기"
      },
      "patient-id": {
        "title": "신원 확인",
        "subtitle": "신원을 확인해 주세요",
        "mode-card": "카드로",
        "mode-search": "검색",
        "mode-create": "새로 만들기",
        "insert-card": "건강보험 카드를 넣어주세요",
        "reading-card": "카드 읽는 중...",
        "simulate-card": "카드 시뮬레이션",
        "multiple-matches": "여러 환자가 발견되었습니다. 카드 데이터를 사용합니다.",
        "search-placeholder": "이름 또는 보험 번호...",
        "searching": "검색 중...",
        "no-results": "결과를 찾을 수 없습니다",
        "first-name": "이름",
        "last-name": "성",
        "dob": "생년월일",
        "insurance": "보험",
        "continue": "계속",
        "creating": "환자 생성 중...",
        "patient-created": "환자가 성공적으로 생성되었습니다!",
        "create-error": "환자를 생성할 수 없습니다."
      },
      "appointment-type": {
        "title": "예약 유형 선택",
        "subtitle": "방문 이유를 선택하세요",
        "loading": "예약 유형 로드 중...",
        "no-types": "사용 가능한 예약 유형 없음",
        "error": "예약 유형을 로드할 수 없습니다. 다시 시도하세요.",
        "no-bookable": "현재 이 예약 유형은 키오스크에서 예약할 수 없습니다. 접수처에 문의하거나 전화로 예약해 주세요.",
        "disabled-default": "이 예약은 접수처에서 직접 또는 전화로 예약해 주세요.",
        "disabled-footer": "접수/전화만 가능",
        "lead": "어떤 종류의 예약을 원하세요?",
        "duration": "약 {{minutes}}분",
        "empty-title": "지금은 여기에서 예약할 수 없습니다",
        "none-bookable-title": "이 예약은 여기에서 할 수 없습니다",
        "none-bookable-body": "접수처에 문의하거나 전화해 주세요."
      },
      "types": {
        "general": "일반 진료",
        "general-desc": "일반적인 증상 및 질문",
        "checkup": "예방 검진",
        "checkup-desc": "정기 건강 검진",
        "vaccination": "예방접종",
        "vaccination-desc": "예방접종 예약",
        "followup": "추적 관찰",
        "followup-desc": "추적 관찰 예약",
        "prescription": "처방전",
        "prescription-desc": "처방전 수령"
      },
      "slot-selection": {
        "title": "예약 선택",
        "subtitle": "사용 가능한 예약을 선택하세요",
        "loading": "사용 가능한 예약 로드 중...",
        "no-slots": "사용 가능한 예약 없음",
        "no-appointment-type": "예약 유형이 선택되지 않음",
        "error": "사용 가능한 슬롯을 로드할 수 없습니다. 다시 시도하세요.",
        "quick-select": "다음 사용 가능한 예약:",
        "select-date": "또는 날짜 선택:",
        "times-for": "{{date}}",
        "available": "사용 가능",
        "unavailable": "예약 없음",
        "slots": "슬롯",
        "select-time-hint": "예약하려면 시간을 터치하세요",
        "week-short": "주",
        "weekday-mon": "월",
        "weekday-tue": "화",
        "weekday-wed": "수",
        "weekday-thu": "목",
        "weekday-fri": "금",
        "weekday-sat": "토",
        "weekday-sun": "일",
        "period-morning": "오전",
        "period-midday": "정오",
        "period-afternoon": "오후",
        "period-evening": "저녁",
        "period-morning-short": "오전",
        "period-midday-short": "정오",
        "period-afternoon-short": "오후",
        "period-evening-short": "저녁",
        "period-dots-legend": "시간 가용성",
        "filter-hint": "선호하는 시간으로 필터링:",
        "or-choose-below": "또는 아래에서 선택하세요",
        "no-slots-period": "슬롯 없음",
        "show-all": "모두 표시",
        "free": "무료",
        "your-selection": "당신의 선택",
        "oclock": "시",
        "choose-slot": "슬롯 선택",
        "choose-day": "날짜 선택",
        "choose-day-first": "먼저 날짜를 선택하세요",
        "times-heading": "{{date}} 예약 가능 시간",
        "time-value": "{{time}}",
        "empty-title": "{{month}}에는 예약 가능한 시간이 없습니다",
        "empty-body": "다음 달을 확인하거나 접수처에 문의하세요. 기꺼이 도와드립니다.",
        "next-month": "다음 달",
        "previous-month": "이전 달"
      },
      "confirmation": {
        "patient-responses": "입력하신 답변",
        "review-loading": "요약 확인 중…",
        "review-unavailable": "요약을 표시할 수 없습니다. 다시 시도하거나 접수처에 문의하세요.",
        "check-booking": "예약 상태 확인",
        "title": "예약 확인",
        "subtitle": "예약 내용을 검토하세요",
        "patient": "환자",
        "datetime": "날짜 및 시간",
        "booking": "예약 중...",
        "confirm": "예약하기",
        "heading": "이게 맞는 것 같나요?",
        "lead": "약속을 확인해 주세요.",
        "appointment": "약속",
        "insured-via": "보험에 가입됨",
        "description-label": "진료실에 전달할 메모(선택 사항)",
        "description-hint": "예약 또는 체크인 시 고려해야 할 사항이 있으면 알려 주세요.",
        "description-placeholder": "예: 거동 제한, 동반자, 중요한 메모",
        "description-too-long": "메모를 500자 이내로 줄여 주세요.",
        "summary": "요약",
        "change": "변경",
        "book-binding": "약속 예약",
        "cancel": "취소",
        "type-label": "예약 종류",
        "datetime-value": "{{date}} {{time}}",
        "name-label": "이름",
        "insurance-label": "보험",
        "insurance-GKV": "공적 건강보험",
        "insurance-PKV": "민간 건강보험",
        "insurance-SELFPAY": "본인 부담",
        "change-time": "예약 변경",
        "description-free-text": "기타 요청 사항(선택)",
        "note-wheelchair": "휠체어를 사용합니다",
        "note-companion": "동행인과 함께 옵니다",
        "note-interpreter": "통역이 필요합니다"
      },
      "done": {
        "title": "예약 완료!",
        "label": "예약됨",
        "subtitle": "예약이 성공적으로 완료되었습니다.",
        "date": "날짜",
        "time": "시간",
        "booking-id": "예약 번호",
        "qr-hint": "캘린더에 추가",
        "qr-description": "스마트폰 카메라로 이 QR 코드를 스캔하여 캘린더 앱에 예약을 추가하세요",
        "auto-redirect": "곧 시작 페이지로 리디렉션됩니다...",
        "auto-redirect-countdown": "{{seconds}}초 후 시작 페이지로 돌아갑니다...",
        "back-to-start": "시작 페이지로",
        "print-button": "예약 확인서 인쇄",
        "print-preparing": "인쇄 화면을 준비하는 중…",
        "print-error": "예약 확인서를 열 수 없습니다. 다시 시도하거나 접수처에 도움을 요청해 주세요.",
        "print-returned": "시스템 인쇄 화면이 닫혔습니다. 필요한 경우 사본을 다시 요청할 수 있습니다.",
        "print-title": "예약 정보",
        "print-location": "장소",
        "print-map-hint": "휴대전화에서 장소 열기",
        "print-error-v2": "예약표를 열 수 없습니다. 다시 시도하거나 접수처에 문의하세요."
      },
      "error": {
        "assistance-info": "예약을 확인하지 못했습니다. 이미 예약되었을 수 있습니다. 접수처에 문의하세요.",
        "pending-title": "예약이 확인되지 않았습니다",
        "pending-info": "예약을 확인하지 못했습니다. 이미 예약되었을 수 있습니다. 다시 확인하거나 접수처에 문의하세요.",
        "title": "예약 실패",
        "subtitle": "예약을 완료할 수 없습니다.",
        "info": "다시 시도하거나 접수처에 문의하세요."
      },
      "phase": {
        "identify": "접수",
        "choose": "시간 선택",
        "confirm": "확인"
      }
    },
    "prescription": {
      "start": {
        "title": "처방전 및 주문",
        "subtitle": "처방전을 확인하거나 리필을 주문하려면 보험 카드를 삽입하세요.",
        "button": "카드 삽입"
      },
      "card-check": {
        "loading": "카드 리더 로드 중...",
        "no-terminal": "구성된 카드 리더가 없습니다.",
        "no-terminal-hint": "도움이 필요하면 직원에게 문의하세요.",
        "insert-card": "카드를 넣어주세요",
        "insert-card-hint": "보험카드를 카드리더기에 삽입하세요.",
        "card-detected": "카드가 감지되었습니다.",
        "reading": "카드를 읽는 중...",
        "reading-hint": "잠시만 기다려주세요.",
        "error": "카드를 읽는 중에 오류가 발생했습니다.",
        "retry": "다시 시도하세요",
        "manual-lookup": "카드 없이 계속하기",
        "load-error": "카드 리더를 로드할 수 없습니다.",
        "read-error": "카드를 읽을 수 없습니다."
      },
      "patient-selection": {
        "title": "환자 선택",
        "subtitle": "다수의 환자가 발견되었습니다. 귀하의 이름을 선택해 주세요.",
        "try-again": "다시 시도하세요",
        "try-again-hint": "카드를 다시 삽입하세요."
      },
      "list": {
        "title": "귀하의 처방전",
        "for-patient": "{{name}} 처방전",
        "loading": "처방전 로드 중...",
        "error-title": "로딩 오류",
        "fetch-error": "처방전을 로드할 수 없습니다.",
        "back-home": "시작으로 돌아가기",
        "done": "완료"
      },
      "detail": {
        "prescription-info": "처방 정보",
        "date": "날짜",
        "prescriber": "처방자",
        "comment": "참고",
        "medications": "약물",
        "form": "양식",
        "pack-size": "팩 크기",
        "manufacturer": "제조업체",
        "loading": "처방전 로드 중...",
        "fetch-error": "처방전 세부정보를 로드할 수 없습니다.",
        "back-to-list": "목록으로 돌아가기",
        "print": "인쇄"
      },
      "types": {
        "public": "공개처방",
        "private": "개인 처방전",
        "long-term": "장기 처방",
        "btm": "마약 처방",
        "g": "친환경 처방",
        "t": "T-처방전"
      },
      "no-patient": {
        "title": "환자를 찾을 수 없음",
        "subtitle": "안타깝게도 이 카드에 해당하는 환자는 발견되지 않았습니다. 도움이 필요하면 직원에게 문의하세요.",
        "try-again": "다시 시도",
        "back-home": "시작으로 돌아가기",
        "title-v2": "일치하는 정보가 없습니다",
        "subtitle-v2": "찾지 못했습니다. 다시 시도하거나 접수처에 문의하세요."
      },
      "done": {
        "title": "감사합니다",
        "subtitle": "이제 자리에 앉아도 됩니다. 궁금한 점이 있으면 직원에게 문의하세요.",
        "no-prescriptions-title": "등록된 처방전이 없습니다.",
        "no-prescriptions-subtitle": "귀하에게 유효한 처방전을 찾을 수 없습니다. 예상하신 분은 리셉션 직원에게 문의해 주세요.",
        "error-title": "오류가 발생했습니다",
        "error-subtitle": "추가 도움이 필요하면 직원에게 문의하세요.",
        "auto-redirect": "{{seconds}} 초 안에 자동 리디렉션",
        "finish": "시작으로 돌아가기"
      },
      "hub": {
        "title": "귀하의 처방전",
        "for-patient": "{{name}} 처방전",
        "loading": "처방전 로드 중...",
        "error-title": "로딩 오류",
        "fetch-error": "처방전을 로드할 수 없습니다.",
        "back-home": "시작으로 돌아가기",
        "done": "완료",
        "order-button": "처방전 주문",
        "existing-prescriptions": "현재 처방전",
        "no-prescriptions": "활성 처방전을 찾을 수 없습니다."
      },
      "patient-lookup": {
        "title": "환자 찾기",
        "subtitle": "이름과 생년월일을 입력하세요.",
        "last-name": "성",
        "first-name": "이름",
        "date-of-birth": "생년월일",
        "lastname": "성",
        "lastname-placeholder": "당신의 성",
        "firstname": "이름",
        "firstname-placeholder": "당신의 이름",
        "dob": "생년월일",
        "search": "검색",
        "searching": "검색 중...",
        "search-error": "검색 오류: {{message}}",
        "no-match": "환자를 찾을 수 없습니다. 귀하의 정보를 확인하시기 바랍니다.",
        "error": "검색 오류입니다. 다시 시도해 주세요.",
        "found": "환자 발견",
        "confirm": "확인",
        "ambiguous": "여러 일치",
        "ambiguous-hint-firstname": "검색 범위를 좁히려면 이름도 입력하세요.",
        "ambiguous-hint-additional": "정보를 확인하시거나 직원에게 문의해 주세요.",
        "not-found": "환자를 찾을 수 없음",
        "not-found-hint": "이러한 세부정보를 갖춘 환자를 찾을 수 없습니다.",
        "not-found-action": "다시 시도하세요"
      },
      "manual-identification": {
        "unverified": "건강보험카드로 본인 확인이 되지 않았습니다. 진료소에서 처리 전에 입력 정보와 요청을 확인합니다."
      },
      "medication-selection": {
        "title": "처방전 요청",
        "subtitle": "의료기관에서 요청을 검토합니다. 승인되면 eRx가 e-prescription 앱에 준비됩니다.",
        "back": "뒤로",
        "submit": "계속 검토하기",
        "reason-title": "왜 처방전이 필요한가요?",
        "reason-hint": "의료기관이 요청을 평가하는 데 도움이 됩니다.",
        "reason-validation": "이유를 선택해 주세요.",
        "reason-schmerzen": "고통",
        "reason-entzuendung": "염증",
        "reason-nachsorge": "수술/시술 후",
        "reason-allergie": "알레르기 / 반응",
        "reason-chronisch": "만성 질환",
        "reason-anderes": "다른 것",
        "medications-title": "어떤 약물?",
        "request-hint": "필요한 것이 무엇인지 설명하거나 갱신하려는 이전 처방전의 이름을 지정하십시오.",
        "request-placeholder": "예를 들어 이부프로펜 600mg, 지난번과 동일",
        "request-validation": "어떤 약이 필요한지 설명해주세요.",
        "history-title": "이전 처방",
        "history-hint": "요청을 미리 작성하려면 항목을 추가하세요.",
        "history-loading": "이전 처방전 로드 중...",
        "history-error": "이전 처방전을 로드할 수 없습니다.",
        "history-add": "추가",
        "history-added": "추가됨",
        "history-date": "마지막: {{date}}",
        "history-request-line": "갱신: {{medicationName}}",
        "urgency-title": "얼마나 긴급한 일인가요?",
        "urgency-hint": "의료기관이 우선순위를 정하는 데 도움이 됩니다.",
        "urgency-soon": "긴급",
        "urgency-soon-meta": "가능한 한 빨리",
        "urgency-tomorrow": "곧",
        "urgency-tomorrow-meta": "앞으로 며칠 안에",
        "urgency-week": "이번주",
        "urgency-week-meta": "시간 압박 없음",
        "lead": "병원에서 요청을 검토합니다. 승인 후 전자처방전은 전자처방전 앱 또는 건강보험 카드에서 확인할 수 있습니다.",
        "history-hint-v2": "이전 처방을 누르면 추가됩니다.",
        "history-retry": "다시 불러오기"
      },
      "request-review": {
        "title": "주문 검토",
        "subtitle": "처방전 요청을 검토하시기 바랍니다.",
        "request-label": "요청된 약물",
        "selected-medications": "선택된 약물",
        "free-text-medications": "추가 약물",
        "freetext-label": "기타",
        "quarterly-warning": "이번 분기에 보험 카드가 읽히지 않았습니다. 의료기관에서 연락할 수 있습니다.",
        "egk-warning": "이번 분기에 보험 카드가 읽히지 않았습니다. 의료기관에서 연락할 수 있습니다.",
        "submit": "제출",
        "submitting": "제출 중...",
        "submit-error": "요청을 제출할 수 없습니다. 다시 시도해 주세요.",
        "back": "뒤로",
        "reason-label": "이유",
        "urgency-label": "긴급함",
        "completion-email-choice": "병원에서 요청 처리를 완료하면 이메일을 받고 싶습니다.",
        "completion-email-label": "이메일 주소",
        "completion-email-placeholder": "name@example.com",
        "completion-email-hint": "이 일회성 알림에만 사용됩니다. 주소는 기본 정보로 저장되지 않습니다.",
        "completion-email-invalid": "올바른 이메일 주소를 입력해 주세요.",
        "egk-proof-required": "처방 요청은 보험 카드가 성공적으로 읽힌 후에만 가능합니다. 직원에게 문의해 주세요.",
        "title-v2": "요청 확인",
        "completion-email-hint-v2": "주소는 이 한 번의 안내에만 사용됩니다."
      },
      "confirmation": {
        "title": "요청이 전송되었습니다",
        "subtitle": "귀하의 처방전 요청이 성공적으로 제출되었습니다.",
        "success-title": "요청이 전송되었습니다",
        "success-subtitle": "귀하의 처방전 요청이 성공적으로 제출되었습니다.",
        "estimated-time": "귀하의 처방전은 대략 {{time}} 후에 준비될 것입니다.",
        "info": "보험 카드나 eRezept 앱을 사용하여 약국에서 처방전을 수령할 수 있습니다.",
        "auto-redirect": "{{seconds}} 초 안에 자동 리디렉션",
        "back-to-start": "시작으로 돌아가기",
        "handling-label": "Handled by the practice",
        "next-steps": "병원에서 요청을 검토합니다. 승인 후 건강보험 카드나 전자처방전 앱으로 약국에서 전자처방전을 사용할 수 있습니다."
      },
      "phase": {
        "identify": "접수",
        "request": "요청",
        "review": "확인"
      }
    },
    "check-in": {
      "flow-label": "체크인",
      "has-appointment": {
        "eyebrow": "약속",
        "title": "예약이 있으신가요?",
        "subtitle": "옵션을 선택하세요",
        "yes-label": "예",
        "yes": "네, 예약이 있습니다",
        "yes-description": "예약에 체크인하고 싶습니다.",
        "yes-hint": "가장 빠른 경로",
        "unsure-label": "어쩌면",
        "unsure": "확실하지 않습니다",
        "unsure-description": "저희가 확인해 드리겠습니다.",
        "unsure-hint": "우리는 당신을 검색할 것입니다",
        "no-label": "아니요",
        "no": "아니요, 예약 없음",
        "no-description": "예약이 없습니다.",
        "no-hint": "워크인"
      },
      "card-check": {
        "eyebrow": "보험카드",
        "title": "건강보험 카드 읽기",
        "subtitle": "건강보험 카드를 리더기에 넣어주세요",
        "insert-title": "건강보험 카드를 카드 리더기에 삽입해 주세요.",
        "insert-detail": "우리는 귀하의 세부 정보를 자동으로 읽습니다. 귀하는 다른 조치를 취할 필요가 없습니다.",
        "other-ways": "다른 방법",
        "no-card-hint": "지금 당장 카드를 가지고 있지 않다면.",
        "pkv-hint": "보험 앱과 함께 QR code를 사용하세요.",
        "loading": "설정 로드 중...",
        "no-terminal": "구성된 카드 리더기가 없습니다. 직원에게 문의하세요.",
        "checking": "카드 확인 중...",
        "insert-prompt": "카드를 넣어주세요...",
        "card-detected": "카드 감지됨! 읽을 준비가 되었습니다.",
        "read-card": "카드 읽기",
        "simulate-insert": "카드 시뮬레이션",
        "reading": "카드 읽는 중...",
        "error": "카드를 읽을 수 없습니다. 다시 시도하세요.",
        "read-error": "카드 데이터 읽기 실패. 다시 시도하세요.",
        "settings-error": "설정을 로드할 수 없습니다. 다시 시도하세요.",
        "no-card-prompt": "카드가 없으신가요?",
        "no-card-action": "수동 검색",
        "connection-warning": "카드 리더기 연결 문제. 기다려 주세요...",
        "pkv-prompt": "개인 보험? Online Check-in",
        "pkv-instruction": "개인 건강 보험 앱으로 이 QR code를 스캔하여 데이터를 디지털 방식으로 전송하세요.",
        "pkv-continue": "수동 등록을 계속하세요.",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "다시 시도하거나 카드 없이 접수하세요. 접수처에서 기꺼이 도와드립니다.",
        "title-pkv": "앱으로 접수",
        "title-reading": "카드를 읽는 중 …",
        "title-unreadable": "카드를 읽을 수 없습니다",
        "title-no-terminal": "카드 없이 접수",
        "no-terminal-body": "카드 리더기를 지금 사용할 수 없습니다. 카드 없이 접수하거나 접수처에 문의하세요.",
        "reading-detail": "카드를 꽂아 두세요. 잠시면 됩니다.",
        "other-ways-title": "다른 방법",
        "no-card-title": "카드 없이 접수",
        "pkv-prompt-title": "민간 보험 가입자이신가요?",
        "pkv-prompt-hint": "민간 의료보험 앱으로 접수",
        "pkv-close": "카드로 접수하기",
        "pkv-instruction-app": "민간 의료보험 앱을 열고 이 코드를 스캔하세요. 정보가 바로 저희에게 전달됩니다."
      },
      "patient-selection": {
        "title": "환자 선택",
        "subtitle": "여러 환자가 발견되었습니다. 본인을 선택하세요.",
        "firstname-label": "당신의 이름",
        "firstname-placeholder": "이름을 입력하세요...",
        "confirm-button": "확인",
        "no-match": "일치하는 환자가 없습니다. 도움을 받으려면 리셉션 데스크로 가세요.",
        "still-ambiguous": "여러 일치 항목이 남아 있습니다. 도움을 받으려면 리셉션 데스크로 가세요.",
        "select-error": "환자 식별에 실패했습니다. 다시 시도해 주세요.",
        "staff-assist": "리셉션으로 이동",
        "title-v2": "간단한 확인",
        "subtitle-v2": "안전을 위해 이름을 입력하세요.",
        "no-match-v2": "이 이름으로는 찾지 못했습니다. 철자를 확인하거나 접수처에 문의하세요.",
        "still-ambiguous-v2": "아직 정확히 찾지 못했습니다. 접수처에 문의하세요.",
        "select-error-v2": "잘 되지 않았습니다. 다시 시도하세요."
      },
      "card-checkin": {
        "title": "체크인 확인",
        "subtitle": "데이터가 성공적으로 읽혔습니다.",
        "confirm": "체크인 확인"
      },
      "register-from-card": {
        "title": "신규 등록",
        "subtitle": "아직 시스템에 등록되지 않았습니다. 등록하시겠습니까?",
        "card-data": "카드 데이터",
        "create": "등록하기",
        "create-error": "등록에 실패했습니다. 다시 시도하거나 직원에게 도움을 요청하십시오.",
        "staff-assist": "직원에게 전화하기",
        "no-card-data-title": "카드 데이터 없음",
        "no-card-data": "카드에서 데이터를 읽을 수 없습니다.",
        "insurance-verified": "보험 확인: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "카드의 정보",
        "subtitle-v2": "정보를 확인하세요. 틀린 부분이 있으면 „변경\"을 누르세요.",
        "create-v2": "정보 확인",
        "create-error-v2": "접수가 되지 않았습니다. 다시 시도하거나 접수처에 문의하세요.",
        "insurer-missing-v2": "카드에 건강보험 정보가 없습니다. 접수처에 문의하세요.",
        "edit": "변경",
        "name": "이름",
        "insurer": "건강보험"
      },
      "patient-lookup": {
        "title": "환자 검색",
        "subtitle": "이름 또는 보험 번호를 입력하세요.",
        "lastname": "성",
        "lastname-placeholder": "당신의 성",
        "dob": "생년월일",
        "firstname": "이름",
        "firstname-placeholder": "당신의 이름",
        "search": "검색",
        "searching": "검색 중...",
        "search-placeholder": "이름 또는 보험 번호...",
        "results-placeholder": "검색 결과가 여기에 표시됩니다",
        "found": "환자 발견!",
        "confirm-identity": "귀하가 표시된 환자인지 확인하십시오.",
        "confirm-button": "그게 나야",
        "ambiguous-firstname": "다수의 환자가 발견되었습니다. 이름을 입력하세요.",
        "ambiguous-additional": "다수의 환자가 발견되었습니다. 직원에게 문의해 주세요.",
        "disambiguation-hint": "이는 귀하를 명확하게 식별하는 데 도움이 됩니다.",
        "not-found": "이러한 세부정보를 갖춘 환자는 발견되지 않았습니다.",
        "error": "검색 오류: {{message}}",
        "staff-assist": "직원에게 전화하기",
        "not-found-prompt": "찾을 수 없나요?",
        "register-new": "신규 등록",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "카드 없이 접수",
        "subtitle-firstname": "이름도 입력하세요.",
        "ambiguous-firstname-v2": "이 성을 가진 사람이 여러 명 있습니다. 이름도 입력하세요.",
        "search-again": "다시 검색",
        "found-v2": "찾았습니다",
        "found-confirm": "„본인입니다\"로 확인하세요.",
        "not-found-title": "찾지 못했습니다",
        "not-found-check": "철자와 생년월일을 확인하세요. 접수처에서 기꺼이 도와드립니다.",
        "not-found-reception": "철자와 생년월일을 확인하거나 접수처에 문의하세요.",
        "ambiguous-additional-v2": "정확히 찾지 못했습니다. 접수처에 문의하세요.",
        "error-v2": "지금은 검색이 되지 않았습니다. 다시 시도하세요."
      },
      "checking-in": {
        "title": "잠시만 기다려 주세요. 체크인 중입니다.",
        "subtitle": "귀하를 치료 대기열에 추가하고 팀에 알리고 있습니다.",
        "step-insurance": "보험 확인됨",
        "step-appointment": "약속이 확인되었습니다",
        "step-waitlist": "대기자 명단에 추가 중",
        "error": "체크인에 실패했습니다. 다시 시도해 주세요.",
        "continue": "무시하고 계속",
        "title-v2": "잠시만 기다려 주세요",
        "loading": "접수 중입니다 …",
        "subtitle-v2": "대기 명단에 등록하고 직원에게 알리고 있습니다.",
        "error-title": "잘 되지 않았습니다",
        "error-v2": "접수를 완료하지 못했습니다.",
        "error-body": "다시 시도하세요. 그래도 안 되면 접수처에서 도와드립니다."
      },
      "appointment-selection": {
        "title": "약속 선택",
        "subtitle": "오늘은 약속이 여러 개 있어요. 하나를 선택해 주세요.",
        "checking-in": "체크인 중...",
        "time": "{{time}}",
        "error-v2": "이 예약의 접수가 되지 않았습니다. 다시 시도하거나 접수처에 문의하세요."
      },
      "no-appointment": {
        "title": "약속을 찾을 수 없습니다.",
        "subtitle": "오늘은 약속을 찾을 수 없습니다. 정기 진료 예약을 해주시기 바랍니다.",
        "book-appointment": "약속 예약",
        "book-appointment-description": "정기 스케줄러를 통해 새로운 약속을 예약하세요.",
        "staff-assist": "직원에게 전화하기",
        "staff-assist-description": "도움이 필요해요.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "오늘 예약을 찾지 못했습니다.",
        "book-v2": "새 예약하기",
        "book-v2-description": "지금 빈 시간을 선택하세요.",
        "have-appointment": "예약이 있습니다",
        "have-appointment-description": "접수처에서 기꺼이 도와드립니다.",
        "unavailable-title": "예약은 접수처에서 해 주세요",
        "subtitle-unavailable": "오늘 예약을 찾지 못했습니다. 접수처에 문의하세요."
      },
      "staff-assist": {
        "title": "직원에게 통보됨",
        "subtitle": "곧 직원이 도와드릴 것입니다.",
        "message": "여기서 기다려주세요. 곧 직원이 귀하와 함께 있을 것입니다.",
        "start-over": "시작으로 돌아가기",
        "auto-redirect": "{{seconds}}초 후에 시작으로 돌아가는 중..."
      },
      "eeb-prompt": {
        "title": "보험 확인",
        "title-failed": "확인 실패",
        "subtitle": "보험을 어떻게 확인하시겠습니까?",
        "subtitle-failed": "보험 앱으로 QR 코드를 스캔하여 확인을 요청하세요.",
        "verify-card": "전자 확인",
        "verify-card-description": "보험사에 요청을 보냅니다.",
        "select-insurer": "보험사 선택",
        "select-insurer-description": "보험사를 수동으로 선택합니다.",
        "skip": "건너뛰기",
        "eyebrow-chip": "대안",
        "eyebrow": "체크인 · 보험 증서(eEB)",
        "recommended": "추천",
        "qr-title": "보험 앱으로 스캔하세요",
        "qr-description": "건강 보험 앱을 열고 코드를 스캔하세요. eEB가 우리에게 직접 전송됩니다.",
        "qr-address-label": "다음으로 보내기",
        "title-app": "앱으로 증명",
        "subtitle-app": "건강보험에서 증명서를 바로 보내 줄 수도 있습니다. 끝나면 „다음\"을 누르세요."
      },
      "quarterly-check": {
        "title": "보험 확인",
        "checking": "현재 보험 확인을 확인하는 중...",
        "error": "확인을 수행할 수 없습니다.",
        "title-v2": "보험 정보",
        "checking-v2": "보험을 확인하고 있습니다 – 잠시만 기다려 주세요.",
        "error-body": "접수가 완료되었습니다. 보험은 접수처에서 함께 확인합니다."
      },
      "insurer-prefilled": {
        "title": "건강 보험",
        "subtitle": "이번 분기의 보험을 확인하세요.",
        "your-insurance": "귀하의 보험",
        "last-read": "마지막 확인: {{date}}",
        "quarterly-notice": "청구 목적으로 이번 분기의 현재 보험 증명이 필요합니다.",
        "confirm-button": "네, 이것이 제 보험입니다",
        "change-button": "다른 보험이 있습니다",
        "contact-title": "전자 보장 증명서 요청",
        "contact-description": "보험에 전화하여 다음 사항에 대한 전자 보장 증명서를 요청하세요.",
        "contact-patient": "환자",
        "contact-kim-address": "의료기관 KIM 주소",
        "contact-phone": "전화",
        "question": "이 건강보험이 맞나요?",
        "quarterly-notice-v2": "분기마다 한 번 건강보험 증명서가 필요합니다."
      },
      "insurer-search": {
        "title": "건강 보험 선택",
        "subtitle": "법정 건강 보험을 검색하고 선택하세요.",
        "placeholder": "보험 검색...",
        "hint": "검색하려면 최소 2자를 입력하세요.",
        "no-results": "보험을 찾을 수 없습니다.",
        "no-results-hint": "철자를 확인하거나 다른 검색을 시도하세요.",
        "label": "건강보험 이름",
        "search-error-v2": "지금은 검색이 되지 않았습니다. 다시 시도하세요.",
        "app-alternative": "건강보험 앱을 사용하시겠어요?"
      },
      "insurer-contact": {
        "title": "보험 증빙 요청",
        "subtitle": "다음 옵션 중 하나를 선택하세요.",
        "or": "또는",
        "option-eeb-title": "전자적으로 요청",
        "option-eeb-description": "법정 예외 사유가 있는 경우, 동의하신 후 요청을 진료팀에 전달하실 수 있습니다.",
        "option-qr-title": "앱으로 스캔",
        "option-qr-description": "보험 앱으로 QR code를 스캔하세요.",
        "option-call-title": "자신에게 전화하기",
        "option-call-description": "보험사에 전화하여 이 의료기관용 eEB를 요청하세요:",
        "phone": "전화",
        "phone-not-available": "보험 카드에 기재된 전화번호",
        "patient-name": "환자",
        "practice-kim": "의료기관 KIM 주소",
        "help-notice": "불편사항이 있으시면 접수데스크를 방문해 주시기 바랍니다.",
        "submit-eeb-button": "지금 요청하세요",
        "contacted-button": "나는 전화했다",
        "contacted-button-countdown": "통화 시간입니다({{seconds}}s)",
        "go-to-counter-button": "리셉션으로 이동",
        "qr-continue-button": "스캔했습니다",
        "qr-continue-button-countdown": "스캔 시간({{seconds}}s)",
        "title-v2": "건강보험 증명서",
        "subtitle-v2": "건강보험 앱이 가장 간편합니다.",
        "subtitle-no-app": "건강보험이 증명서를 보낼 방법을 선택하세요.",
        "option-eeb-description-v2": "저희가 대신 건강보험에 요청합니다. 이를 위해 동의가 필요합니다.",
        "call-instruction": "건강보험에 전화해 증명서를 저희 병원으로 보내 달라고 요청하세요.",
        "call-instruction-practice": "건강보험에 전화해 증명서를 {{practice}}(으)로 보내 달라고 요청하세요.",
        "done-button": "완료 – 다음",
        "done-button-countdown": "완료 – 다음 ({{seconds}}초 남음)"
      },
      "eeb-consent": {
        "title": "동의",
        "subtitle": "전자 보험 확인을 위해 귀하의 동의가 필요합니다.",
        "insurance": "귀하의 보험",
        "consent-title": "전자 보험 확인 동의 (eEB)",
        "consent-text": "본인은 건강보험사가 보험 증명으로 제 보험 데이터(예: 이름, 생년월일, 보험 번호)를 안전한 KIM 통신 서비스를 통해 의료기관 {{practiceName}}에 전송한다는 것을 이해합니다. 이 전송에 동의합니다. 본인은 치료에 영향을 주지 않고 언제든지 이 동의를 철회할 수 있음을 알고 있습니다.",
        "withdrawal-notice": "이 동의는 언제든지 철회할 수 있습니다.",
        "agree-button": "동의합니다",
        "decline-button": "취소",
        "treatment-notice": "귀하의 치료는 이 동의의 영향을 받지 않습니다.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "건강보험 증명서",
        "summary": "건강보험이 증명서를 바로 보내 드립니다. 이를 위해 동의가 필요합니다.",
        "confirm-first": "먼저 선언에 동의해 주세요."
      },
      "qr-code": {
        "title": "보험 앱으로 스캔",
        "instruction-1": "보험 앱을 열고 이 QR 코드를 스캔하세요.",
        "instruction-2": "그러면 의료기관이 보험 확인을 자동으로 받습니다.",
        "practice": "의료기관: {{name}}",
        "alternative-hint": "대안: 보험 앱 사용",
        "instruction-app": "건강보험 앱을 열고 이 코드를 스캔하세요. 증명서가 바로 저희에게 전달됩니다.",
        "staff-line": "병원 직원용: {{address}}",
        "staff-line-practice": "병원 직원용: {{name}} · {{address}}",
        "alternative-app": "건강보험 앱으로도 증명서를 요청할 수 있습니다: 앱을 열고 이 코드를 스캔하세요."
      },
      "register-basics": {
        "title": "개인 정보",
        "subtitle": "정보를 입력하세요.",
        "family-name": "성",
        "given-name": "이름",
        "dob": "생년월일",
        "gender": "성별",
        "insurance-type": "보험 유형",
        "insurer-name": "보험 이름",
        "insurer-name-placeholder": "예를 들어 데베카, DKV, 알리안츠...",
        "gender-required": "하나를 선택하세요."
      },
      "register-insurer": {
        "title": "건강 보험",
        "subtitle": "건강 보험을 선택하세요.",
        "search-placeholder": "보험 검색..."
      },
      "register-details": {
        "title": "요약",
        "subtitle": "정보를 검토하세요.",
        "create": "등록 완료",
        "missing-data": "필수 입력란을 모두 작성해 주세요.",
        "create-error": "등록에 실패했습니다. 다시 시도해 주세요.",
        "policy-number": "정책 번호(선택사항)",
        "policy-number-placeholder": "귀하의 보험 증권 번호",
        "create-v2": "접수 완료",
        "policy-number-hint": "번호는 보험 카드에 있습니다."
      },
      "diff-review": {
        "eyebrow-chip": "검토",
        "eyebrow": "체크인 · 카드 데이터",
        "title": "데이터 비교",
        "subtitle": "카드 데이터와 기록 사이에 차이가 발견되었습니다.",
        "col-current": "현재 기록",
        "col-new": "카드에서 새로 만들기",
        "new-badge": "새로운",
        "field-fallback": "필드",
        "note": "업데이트된 데이터는 요금을 올바르게 청구하고 긴급 상황 시 귀하에게 연락하는 데 도움이 됩니다.",
        "comparison-placeholder": "비교가 여기에 표시됩니다",
        "confirm": "변경 사항 확인",
        "apply-error": "데이터를 적용할 수 없습니다. 다시 시도해 주세요.",
        "retry": "다시 시도하세요",
        "skip": "무시하고 계속",
        "no-changes": "변경 사항 없음",
        "title-v2": "정보가 바뀌었습니다",
        "subtitle-v2": "카드에 최신 정보가 있습니다. 반영할까요?",
        "confirm-v2": "반영하고 접수",
        "keep": "변경 없이 접수",
        "col-current-v2": "기존",
        "col-new-v2": "카드의 새 정보",
        "value-yes": "예",
        "value-no": "아니요"
      },
      "insurance-selection": {
        "title": "보험 유형",
        "subtitle": "보험 유형을 선택하세요.",
        "gkv": "법정 보험",
        "gkv-description": "법정 건강 보험 회원.",
        "pkv": "민간 또는 자비 부담",
        "pkv-description": "민간 보험 또는 자비 부담.",
        "pkv-description-v2": "민간 의료보험 또는 본인 부담."
      },
      "eeb-request": {
        "title": "요청이 접수되었습니다",
        "subtitle": "체크인을 완료하실 수 있습니다. {{insurer}}의 회신은 나중에 진료실에 도착합니다.",
        "verifying": "요청이 즉시 처리를 위해 접수되었습니다.",
        "success": "요청이 안전하게 진료팀에 전달되었습니다.",
        "error": "요청 확인을 사용할 수 없습니다.",
        "try-alternative": "대체 방법",
        "kim-load-error": "의료기관 KIM 주소를 불러올 수 없습니다.",
        "kim-label": "의료기관 · KIM",
        "non-blocking-note": "이것은 아직 건강보험사의 수신이나 귀하의 보험 상태를 확인하는 것이 아닙니다.",
        "auto-continue": "{{seconds}}초 후 자동으로 진행됩니다.",
        "unavailable-title": "잘 되지 않았습니다",
        "unavailable-v2": "건강보험 요청을 기록하지 못했습니다.",
        "unavailable-body": "건강보험 앱으로 증명서를 받거나 접수처에서 처리할 수 있습니다.",
        "use-app": "앱으로",
        "at-reception": "접수처에서 처리"
      },
      "self-pay": {
        "title": "자비 부담",
        "subtitle": "자비 부담 환자로 치료받게 됩니다.",
        "info": "치료 비용에 대한 책임은 귀하에게 있음을 유의하세요.",
        "confirm": "이해했습니다",
        "title-v2": "본인 부담",
        "subtitle-v2": "치료비를 직접 부담합니다.",
        "insured-after-all": "보험이 있습니다"
      },
      "done": {
        "title": "완료!",
        "subtitle": "체크인이 완료되었습니다.",
        "finish": "종료",
        "done-label": "완료",
        "error-label": "공지사항",
        "eyebrow": "체크인 · 완료",
        "queue-label": "대기실",
        "queue-title": "자리에 앉으세요",
        "queue-meta": "개별적으로 전화드리겠습니다.",
        "success-title": "체크인 성공!",
        "success-subtitle": "대기실에 앉아주세요. 곧 호출됩니다.",
        "auto-redirect": "곧 시작 페이지로 리디렉션됩니다...",
        "auto-redirect-countdown": "{{seconds}}초 후에 시작으로 돌아가는 중...",
        "card-expired-title": "카드 만료",
        "card-expired-subtitle": "건강보험 카드가 만료되었습니다.",
        "card-expired-info": "도움이 필요하면 직원에게 문의하세요.",
        "back-to-start": "시작 페이지로",
        "anamnesis-title": "병력 양식 작성",
        "anamnesis-description": "QR code를 스캔하여 스마트폰에서 병력 양식을 편리하게 작성하세요.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "접수되었습니다",
        "card-expired-info-v2": "접수처에 문의하세요."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "정보 확인",
          "balance-prefix": "저장 시:",
          "balance-direct-v2": "바로 저장: {{count}}",
          "balance-reception-v2": "접수처 확인: {{count}}",
          "chip-reception-v2": "변경 사항은 접수처에서 확인합니다",
          "chip-changed": "변경됨: {{count}}",
          "remove": "삭제",
          "example-email": "예: name@example.kr",
          "example-phone": "예: 010 1234 5678",
          "intro-v2": "접수가 완료되었습니다. 이 정보가 아직 맞나요? 확인은 선택 사항입니다.",
          "auto-hide": "표시된 값은 잠시 후 다시 숨겨집니다."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "이 정보를 접수처에 전달했습니다.",
          "banner-done-v2": "감사합니다! 정보를 받았습니다.",
          "footer-v2": "다른 정보는 그대로 유지됩니다."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "개인정보 보호를 위해 화면을 닫았습니다. 접수는 완료되었습니다. 변경 사항은 언제든지 접수처에 알려 주세요."
        }
      },
      "progress": {
        "identify": "접수",
        "insurance": "보험",
        "done": "완료"
      },
      "dob-format-hint": "예: 01.10.1980",
      "dob-required": "생년월일을 입력하세요.",
      "insurance-label": {
        "GKV": "공보험",
        "PKV": "민간 보험",
        "SELFPAY": "본인 부담"
      }
    },
    "emergency": {
      "title": "긴급 비상!",
      "label": "긴급상황",
      "subtitle": "이 알림은 현장에서만 들리며 도움을 요청하지 않았습니다. 급성 또는 생명을 위협할 수 있는 응급 상황에는 112로 전화하세요.",
      "call-emergency": "긴급 서비스에 전화하세요(112)",
      "stop-sound": "소리 중지",
      "play-sound": "소리 재생",
      "back-to-start": "시작으로 돌아가기",
      "headline": "즉시 접수처 직원에게 말씀하세요. 생명이 위험하면 112에 전화하세요."
    },
    "help-reception": "리셉션 도움",
    "help-reception-toast": "리셉션에 문의하시기 바랍니다. 기꺼이 도와드리겠습니다.",
    "language-entry": {
      "title": "언어를 선택하세요"
    },
    "loading": "불러오는 중…",
    "step-progress-label": "진행 상황",
    "step-progress-phase": "{{total}}개 중 {{current}}번째 단계: {{phase}}",
    "step-progress-substep": "{{total}}개 중 {{current}}번째 부분",
    "step-progress-complete": "완료됨",
    "identification": {
      "title": "누구신가요?",
      "lead": "건강보험 카드를 사용하는 것이 가장 빠릅니다. 이름으로 검색할 수도 있습니다.",
      "lead-card-only": "건강보험 카드를 카드 리더기에 넣어 주세요.",
      "mode-label": "어떻게 접수하시겠어요?",
      "mode-card": "카드로",
      "mode-search": "이름으로 검색",
      "mode-create": "처음 방문",
      "card": {
        "loading": "카드 리더기를 준비하는 중 …",
        "checking": "카드 리더기를 확인하는 중 …",
        "insert-title": "건강보험 카드를 카드 리더기에 넣어 주세요.",
        "insert-detail": "정보는 자동으로 읽습니다.",
        "detected": "카드 인식됨",
        "read": "카드 읽기",
        "reading": "카드를 읽는 중 …",
        "reading-hint": "카드를 꽂아 둔 채로 두세요.",
        "no-terminal-title": "카드 리더기를 사용할 수 없습니다",
        "help-with-search": "이름으로 검색하거나 접수처에 문의하세요.",
        "help-reception": "접수처에 문의하세요. 기꺼이 도와드립니다.",
        "unreadable-title": "카드는 인식되었지만 읽을 수 없습니다",
        "error-title": "카드를 읽을 수 없습니다",
        "not-unique": "이 카드로 본인을 명확히 확인하지 못했습니다. 이름으로 검색하거나 접수처에 문의하세요.",
        "no-match": "이 카드에 맞는 정보를 찾지 못했습니다. 이름으로 검색하거나 접수처에 문의하세요.",
        "without-card": "카드 없이 계속"
      },
      "lookup": {
        "lead": "성과 생년월일을 입력하세요.",
        "first-name": "이름",
        "last-name": "성",
        "dob": "생년월일",
        "dob-hint": "형식: 일.월.연도",
        "search": "검색",
        "confirm": "네, 저입니다",
        "found-title": "찾았습니다",
        "found-body": "본인이 맞는지 확인해 주세요.",
        "first-name-needed-title": "이름을 입력해 주세요",
        "first-name-needed-body": "본인을 명확히 찾기 위해서입니다. 그런 다음 ‘검색’을 누르세요.",
        "ambiguous-title": "본인을 명확히 찾지 못했습니다",
        "ambiguous-body": "접수처에 문의하세요. 기꺼이 도와드립니다.",
        "not-found-title": "일치하는 정보가 없습니다",
        "not-found-body": "입력한 내용을 확인해 주세요.",
        "error-title": "지금은 검색할 수 없습니다",
        "error-body": "다시 시도하거나 접수처에 문의하세요."
      },
      "create": {
        "insurance-question": "어떤 보험에 가입되어 있나요?",
        "insurance-required": "보험 종류를 선택해 주세요.",
        "error-title": "정보를 저장할 수 없습니다",
        "error-body": "다시 시도하거나 접수처에 문의하세요."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "먼저 잠금해제",
      "subtitle": "FrontDesk+는 실습 소프트웨어에서 활성화되어야 합니다.",
      "step1": "SolStore(또는 귀하의 Doc-Cirrus 파트너 주문)로 주문하세요.",
      "step2": "활성화 후 “inSuite Sols”(관리자 권한) 아래의 inSuite에서 활성화하세요.",
      "step3": "Bridge 관리 → \"장치 추가\"를 엽니다.",
      "cta": "모두 완료 - 계속 진행"
    },
    "welcome": {
      "title": "실습에 이 장치를 추가하세요",
      "scan": "코드 사진을 찍으세요.",
      "prepare-link": "inSuite에 코드가 없나요?",
      "language": "언어"
    },
    "scan": {
      "requesting": "카메라 접근 권한이 요청되었습니다…",
      "scanning": "카메라를 코드로 향하게 하세요.",
      "paste": "대신 붙여넣기",
      "manual-title": "수동으로 연결",
      "manual-description": "QR 코드를 사용할 수 없는 경우 Bridge 관리에서 연결 데이터를 가져옵니다.",
      "address-label": "Bridge주소",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "SOLTOKEN 삽입",
      "manual-submit": "연결 인계",
      "error-title": "코드가 인식되지 않음",
      "camera-denied-title": "카메라 액세스가 거부되었습니다.",
      "camera-denied-hint": "설정에서 카메라 액세스를 허용한 후 다시 시도해 주세요.",
      "retry": "다시 시도하세요"
    },
    "preflight": {
      "title": "설정됩니다",
      "all-green": "모든 테스트 통과",
      "practice": "관행",
      "device-name": "장치 이름",
      "device-name-placeholder": "예를 들어 나. 접수1",
      "card-reader": "카드 리더기",
      "pin": "새로운 비밀번호",
      "pin-placeholder": "4자리 PIN",
      "finish": "마치다",
      "recheck": "다시 확인하세요",
      "diagnosis": "진단ID",
      "checklist-error": "Bridge가 연결을 거부했거나 연결할 수 없습니다. SOLTOKEN과 Bridge 주소를 확인하세요.",
      "checklist-retry": "다시 확인",
      "edit-token": "SOLTOKEN 변경",
      "rescan": "코드 다시 스캔"
    },
    "persisting": "설정을 저장하는 중 …",
    "success": {
      "title": "기기가 추가됨",
      "detail": "방금 연습용 PC에 장치가 나타났습니다.",
      "starting": "환자 모드가 시작되는 중입니다…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "실습 소프트웨어에 연결",
        "fix": "Bridge 연결 및 서버 주소를 확인하세요."
      },
      "missing_insuite_url": {
        "label": "inSuite 주소",
        "fix": "QR 코드를 다시 스캔하세요. 주소가 누락되었습니다."
      },
      "missing_server_token": {
        "label": "서버 토큰",
        "fix": "QR 코드를 다시 스캔하세요. 토큰이 없습니다."
      },
      "missing_gateway_session": {
        "label": "Gateway 세션",
        "fix": "다시 로그인하세요. 세션이 없습니다."
      },
      "missing_gateway_enrollment": {
        "label": "장치 등록",
        "fix": "Gateway에 장치를 등록하세요."
      },
      "gateway_not_ready": {
        "label": "Gateway 준비",
        "fix": "Gateway가 설정을 완료할 때까지 기다립니다."
      },
      "token_verification_failed": {
        "label": "토큰 확인",
        "fix": "서버 토큰 또는 Bridge 연결을 확인하세요."
      },
      "session_expired": {
        "label": "회의",
        "fix": "세션이 만료되었습니다. 다시 로그인하세요."
      },
      "device_revoked": {
        "label": "장치 상태",
        "fix": "이 장치는 차단되었습니다. 실습에 문의하십시오."
      },
      "missing_practice_name": {
        "label": "실무명",
        "fix": "진료소 이름을 로드할 수 없습니다 (inSuite)."
      },
      "missing_device_name": {
        "label": "장치 이름",
        "fix": "장치 이름을 입력하세요."
      },
      "telematik_unavailable": {
        "label": "텔레매틱스 인프라",
        "fix": "선택 사항 - TI가 출시되는 즉시 카드 확인이 가능합니다."
      },
      "selected_card_reader_unavailable": {
        "label": "카드 리더기",
        "fix": "선택 사항 - 카드 리더를 선택하거나 연결합니다."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "선택 사항 - 의료 행위 자격증명 카드 삽입 (SMC-B)."
      }
    },
    "token": {
      "title": "SOLTOKEN 입력",
      "description": "보안상의 이유로 QR 코드에는 SOLTOKEN이 포함되어 있지 않습니다. inSuite의 'Sol-Aktivierung'(FrontDesk+)에서 복사하여 여기에 붙여 넣으세요.",
      "submit": "계속",
      "rescan": "코드 다시 스캔"
    }
  }
}
